export const en = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Services',
    portfolio: 'Portfolio',
    process: 'Process',
    about: 'About',
    history: 'Our History',
    testimonials: 'Testimonials',
    faq: 'FAQ',
    contact: 'Contact'
  },

  // Hero Section
  hero: {
    tagline: 'ARCHITECTURE & DESIGN',
    title: 'CREATING EXCELLENCE',
    subtitle: 'IN EVERY DETAIL',
    description: 'Architecture firm in Madagascar specializing in the design of modern houses and contemporary villas in Antananarivo. We create unique architectural spaces that combine innovation, functionality and aesthetics.',
    cta: {
      projects: 'DISCOVER OUR PROJECTS',
      contact: 'CONTACT US'
    },
    vision: {
      title: 'OUR VISION',
      description: 'In Madagascar, we transform every residential and commercial project into an exceptional architectural work in Antananarivo, harmonizing creativity, sustainable construction and innovation.'
    }
  },

  // Stats
  stats: {
    projects: 'Projects Completed',
    experience: 'Years of Experience',
    clients: 'Satisfied Clients',
    locations: 'Locations Covered'
  },

  // Services Section
  services: {
    title: 'OUR SERVICES',
    intro: 'We offer comprehensive expertise in residential design, commercial architecture and interior design to bring your most ambitious projects to life.',
    description1: 'M.A CONCEPT supports individuals, businesses and real estate developers through all phases of their architectural projects. From initial feasibility studies to final delivery, our team of qualified architects puts their expertise at the service of your vision. We operate throughout Madagascar, with particular expertise in Antananarivo and the Analamanga region.',
    description2: 'Our integrated approach combines architecture, interior design and construction consulting to offer you a complete and consistent service. Each project benefits from personalized attention and a creative approach adapted to your specific needs, budget and site constraints. Discover our four main areas of expertise:',
    items: [
      {
        title: 'Residential Architecture',
        description: 'Design of minimalist-style houses and residences, customized to each client\'s needs and incorporating features that comply with architectural standards. Our expertise covers the design of contemporary villas, individual houses, luxury residences and modern apartments. We create living spaces that reflect your personality while optimizing comfort, natural light and energy efficiency. Each residential project benefits from an in-depth study of the land, solar orientation and landscape integration to ensure perfect harmony with the Malagasy environment.',
        icon: '🏠',
        features: [
          'Custom plans adapted to your lifestyle',
          'Interior design and complete layout',
          'Work supervision and craftsman coordination',
          'Energy optimization and sustainable development'
        ]
      },
      {
        title: 'Commercial Architecture',
        description: 'Creation of innovative commercial spaces optimized for customer experience and commercial performance. Our team designs modern offices, shopping centers, showrooms, restaurants and retail spaces that combine contemporary aesthetics with optimal functionality. We understand the circulation, visibility and attractiveness challenges specific to commercial spaces. Each commercial project is designed to maximize return on investment while creating a strong architectural identity that distinguishes your business in Madagascar.',
        icon: '🏢',
        features: [
          'Shopping centers and commercial galleries',
          'Modern offices and coworking spaces',
          'Attractive retail spaces and showrooms',
          'Restaurant space design'
        ]
      },
      {
        title: 'Renovation & Extension',
        description: 'Transformation and modernization of existing buildings with respect for Malagasy architectural heritage. We breathe new life into your property while preserving its unique character and integrating contemporary comfort standards. Whether it\'s expanding your living space, restructuring room distribution or modernizing facilities, our respectful approach enhances what already exists. We manage the entire renovation process, from structural feasibility studies to final delivery, respecting agreed deadlines and budgets.',
        icon: '🔧',
        features: [
          'Complete renovation of old buildings',
          'Extensions and elevations',
          'Energy and safety compliance upgrades',
          'Space restructuring and redistribution'
        ]
      },
      {
        title: 'Consultation & Expertise',
        description: 'Expert guidance to optimize your architectural and real estate projects in Madagascar. Our consultation service offers strategic advice at every stage of your project: site analysis, technical and financial feasibility study, construction cost optimization and regulatory advice. We help you make the right decisions from the start to avoid costly mistakes. Our local expertise of the Malagasy market and our knowledge of urban planning regulations in Antananarivo are valuable assets for the success of your real estate investment.',
        icon: '📋',
        features: [
          'Feasibility study and site analysis',
          'Technical advice and material selection',
          'Project monitoring and general coordination',
          'Administrative assistance and building permits'
        ]
      },
      {
  title: 'Real Estate Services',
  description: 'Comprehensive real estate services dedicated to land and property transactions in Madagascar. We support individuals and investors in the sale of land, administrative file processing and real estate project preparation. Our expertise ensures secure, transparent and well-structured transactions, from initial property verification to final transfer. In the near future, our services will also include the sale of completed buildings and real estate developments, offering turnkey solutions for buyers and investors.',
  icon: '🏞️',
  features: [
    'Land sales and property valuation',
    'Administrative file processing and legal assistance',
    'Verification of land titles and ownership documents',
    'Future sale of buildings and real estate projects'
  ]
},
{
  title: 'Web Development (Full-Stack)',
  description: 'Design and development of modern, scalable and secure web applications tailored to your business needs. As a full-stack developer, we handle both front-end and back-end development to deliver complete digital solutions. From corporate websites to custom management platforms, dashboards and e-commerce systems, we build high-performance web applications with a strong focus on usability, reliability and maintainability. Each project is designed to support business growth and digital transformation.',
  icon: '💻',
  features: [
    'Corporate websites and professional portfolios',
    'Custom web applications and dashboards',
    'Admin panels and user management systems',
    'Database design, API integration and maintenance'
  ]
}
    ]
  },

  // Portfolio Section
  portfolio: {
    title: 'PORTFOLIO',
    subtitle: 'Discover our architectural achievements that redefine living and working spaces.',
    projects: [
      {
        id: 1,
        title: 'Contemporary Residential Tower',
        description: 'The twilight sky unfolds a spectacular palette of purples and oranges, with streaked clouds capturing the fading light. On the ground, the environment consists of light concrete architectural masses and vegetation dotted with mature trees, all enhanced by landscape lighting that highlights the volumes and textures of the nocturnal landscape.',
        year: '2025',
        location: 'Madagascar',
        category: 'Residential'
      },
      {
        id: 2,
        title: 'Garden Villa with Integrated Landscape',
        description: 'The building\'s exterior design, with its clean lines, large bay windows and alternating wood cladding and dark facing, establishes a direct visual and material connection with the outdoor layout. The garden design, integrating lawn areas, purple floral plantings and a majestic tree surrounded by a circular wooden seat, reflects and extends the palette of natural textures and colors of the building.',
        year: '2025',
        location: 'Madagascar',
        category: 'Residential'
      },
      {
        id: 3,
        title: 'Ecological Solar Energy House',
        description: 'This modern residential project features contrasting cubic architecture, combining a white base and light wood cladding with a dark gray upper floor under a low-pitched roof equipped with solar panels. The arrangement of rectangular windows, of varying sizes and often in ribbon form, maximizes natural light intake while maintaining a clean, contemporary aesthetic.',
        year: '2025',
        location: 'Madagascar',
        category: 'Residential'
      },
      {
        id: 4,
        title: 'Four Semi-Detached Villas Complex',
        description: 'This architectural concept presents four residential units harmoniously integrated into a green landscape, optimizing orientation for natural light and views. Each unit combines modern materials such as light wood cladding and dark or white facades, creating an aesthetic contrast and strong visual connection with the surrounding nature.',
        year: '2025',
        location: 'Madagascar',
        category: 'Residential'
      },
      {
        id: 5,
        title: 'Contemporary Dining Room',
        description: 'This urban dining space embodies contemporary design through its marriage of refined materials like marble and emerald green velvet, an abundance of filtered natural light, and clean lines that create an atmosphere that is both elegant and functional.',
        year: '2025',
        location: 'Madagascar',
        category: 'Residential'
      },
      {
        id: 6,
        title: 'Urban Master Suite',
        description: 'This urban master bedroom combines contemporary aesthetics with bold contrasts, where a dark wood accent wall and dark tones are balanced by touches of natural light and dynamic artwork. The functional layout and streamlined furniture create a sophisticated sanctuary offering stunning city views.',
        year: '2025',
        location: 'Madagascar',
        category: 'Residential'
      }
    ]
  },

  // About Section
  about: {
    title: 'ABOUT M.A CONCEPT',
    paragraphs: [
      'Founded on a vision of architectural excellence, M.A CONCEPT has established itself as a reference in creating innovative and sustainable spaces in Madagascar. Our architecture firm based in Antananarivo stands out through a contemporary and personalized approach to architectural design.',
      'Our unique approach combines artistic creativity, technical expertise and environmental respect to bring to life projects that mark their era. We firmly believe that architecture must meet functional needs while creating emotions and integrating harmoniously into the Malagasy context. Every line, every volume, every material is carefully chosen to create spaces that transcend expectations.',
      'At M.A CONCEPT, we don\'t simply construct buildings, we create living environments that improve the daily lives of their occupants. Our multidisciplinary team of architects and designers works closely with our clients to transform their dreams into architectural reality. From the first sketch to key handover, we accompany each project with passion and professionalism.',
      'Each project is an opportunity to explore new architectural possibilities, placing humans at the heart of our concerns and anticipating tomorrow\'s needs. We integrate sustainable development principles, energy optimization and the use of local materials whenever possible into our designs. Our deep knowledge of Madagascar\'s tropical climate allows us to design naturally comfortable buildings, thus reducing dependence on artificial air conditioning systems.',
      'Located in the heart of Antananarivo, we extend our services throughout Madagascar for residential, commercial and renovation architecture. Our diverse portfolio demonstrates our ability to meet all architectural challenges, from contemporary villas to residential complexes, from innovative commercial spaces to heritage renovation projects. Client satisfaction and quality of our achievements remain our absolute priorities.'
    ],
    mission: {
      title: 'OUR MISSION',
      description: 'Create exceptional architectures that transform how we live, work and interact with our environment.'
    }
  },

  // Testimonials Section
  testimonials: {
    title: 'TESTIMONIALS',
    subtitle: 'Our clients\' satisfaction reflects our commitment to architectural excellence.',
    items: [
      {
        id: 1,
        name: 'Andriantsoa Rakoto',
        role: 'Homeowner',
        comment: 'M.A CONCEPT transformed our vision into a reality that exceeds our expectations. Their professional and creative approach is remarkable.',
        project: 'Residential Project'
      },
      {
        id: 2,
        name: 'Karim Alaoui',
        role: 'Commercial Director',
        comment: 'Exceptional work on our shopping center. The team successfully combined modern aesthetics with optimal functionality.',
        project: 'Futuristic Shopping Center'
      },
      {
        id: 3,
        name: 'Fatima Zahra',
        role: 'Partner Architect',
        comment: 'Collaboration with M.A CONCEPT is always enriching. Their innovative vision brings real added value to our projects.',
        project: 'Ecological Residence'
      }
    ]
  },

  // Contact Section
  contact: {
    title: 'CONTACT US',
    subtitle: 'Ready to bring your architectural vision to life? Let\'s discuss your project and create something exceptional together.',
    phone: 'PHONE',
    email: 'EMAIL',
    hours: {
      title: 'BUSINESS HOURS',
      weekdays: 'Monday - Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed'
    },
    form: {
      title: 'TELL US ABOUT YOUR PROJECT',
      name: 'NAME',
      namePlaceholder: 'Your name',
      emailLabel: 'EMAIL',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+261 XX XXX XXXX',
      projectType: 'PROJECT TYPE',
      projectTypePlaceholder: 'Select a project type',
      projectTypes: {
        villa: 'Villa / Individual House',
        apartment: 'Apartment / Renovation',
        commercial: 'Commercial / Office',
        industrial: 'Industrial Building',
        mixed: 'Mixed Project',
        other: 'Other'
      },
      budget: 'ESTIMATED BUDGET',
      budgetPlaceholder: 'Select a range',
      budgetRanges: {
        under500k: 'Under 500,000 Ar',
        '500k-1m': '500,000 - 1,000,000 Ar',
        '1m-2m': '1,000,000 - 2,000,000 Ar',
        '2m-5m': '2,000,000 - 5,000,000 Ar',
        over5m: 'Over 5,000,000 Ar'
      },
      description: 'PROJECT DESCRIPTION',
      descriptionPlaceholder: 'Describe your vision, needs, technical constraints, desired timelines...',
      submit: 'SEND REQUEST',
      submitting: 'SENDING...',
      success: 'Your request has been sent successfully! Our team will contact you within 24 hours.',
      error: 'An error occurred while sending. Please try again or contact us directly at +261349838111.',
      consent: 'By submitting this form, you agree to be contacted by M.A CONCEPT regarding your architectural project.'
    }
  },

  // Footer
  footer: {
    description: 'Malagasy architecture firm in Antananarivo specializing in creating modern houses, contemporary villas and innovative commercial spaces that redefine the art of living in Madagascar.',
    services: 'SERVICES',
    contactTitle: 'CONTACT',
    phone: 'Phone',
    email: 'Email',
    legal: {
      rights: '© 2025 M.A CONCEPT. All rights reserved.',
      legalNotice: 'Legal Notice',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    },
    footerServices: [
      {
        id: 'residential-architecture',
        title: 'Residential Architecture',
        description: 'Design of modern houses and personalized contemporary villas. We create unique living spaces that reflect your personality while optimizing comfort and energy efficiency.'
      },
      {
        id: 'commercial-architecture',
        title: 'Commercial Architecture',
        description: 'Creation of innovative commercial spaces: modern offices, shopping centers, showrooms and restaurants that maximize your return on investment.'
      },
      {
        id: 'renovation-extension',
        title: 'Renovation & Extension',
        description: 'Transformation and modernization of existing buildings. We breathe new life into your property while preserving its unique character and integrating contemporary standards.'
      },
      {
        id: 'interior-design',
        title: 'Interior Design',
        description: 'Custom interior design and decoration. We create unique and functional atmospheres that transform your living spaces into exceptional places.'
      },
      {
        id: 'technical-consultation',
        title: 'Technical Consultation',
        description: 'Expert advice to optimize your projects: feasibility study, site analysis, material selection and administrative assistance.'
      },
      {
        id: 'site-supervision',
        title: 'Site Supervision',
        description: 'Complete coordination of your construction project: work supervision, craftsman management, quality control and deadline compliance.'
      }
    ]
  },

  // Team
  team: [
    {
      id: 1,
      name: 'Ny Antsa',
      profession: 'Urban Planner',
      specialization: 'Architecture & Sustainable Development'
    },
    {
      id: 2,
      name: 'Sariaka',
      profession: 'Artist',
      specialization: 'Of 3D renderings'
    },
    {
      id: 3,
      name: 'Clément',
      profession: 'Developer',
      specialization: 'Full Stack'
    }
  ],

  // Process Section
  process: {
    title: 'OUR PROCESS',
    subtitle: 'From idea to completion, we guide you through every step of your architectural project.',
    steps: [
      {
        number: 1,
        title: 'Consultation',
        description: 'Meeting to understand your needs, your land and define your budget.'
      },
      {
        number: 2,
        title: 'Study & Sketches',
        description: 'Site analysis and creation of initial sketches for your project.'
      },
      {
        number: 3,
        title: 'Technical Plans',
        description: 'Design of detailed 2D plans and complete 3D modeling.'
      },
      {
        number: 4,
        title: '3D Renderings',
        description: 'Photorealistic visualizations to envision your future space.'
      },
      {
        number: 5,
        title: 'Building Permit',
        description: 'Document preparation and support through administrative procedures.'
      },
      {
        number: 6,
        title: 'Site Supervision',
        description: 'Work coordination and quality control until delivery.'
      }
    ]
  },

  // FAQ Section
  faq: {
    title: 'FREQUENTLY ASKED QUESTIONS',
    subtitle: 'Find answers to the most common questions about our architecture services.',
    items: [
      {
        question: 'What services do you offer exactly?',
        answer: 'We offer a complete range of services: architectural design (technical plans and 3D modeling), photorealistic renderings, building permit assistance, and construction site supervision. We support you from the first sketch to the delivery of your project.'
      },
      {
        question: 'How does the design process work?',
        answer: 'Everything starts with a meeting to understand your needs, your land, and your budget. We then create initial sketches, and after validation, we move on to detailed technical plans and 3D visualizations. You approve each step before proceeding, ensuring a result that matches your expectations.'
      },
      {
        question: 'Do you provide 3D plans and realistic renderings?',
        answer: 'Yes, we create complete 3D models and high-quality photorealistic renderings using professional architectural design software. These visuals allow you to envision your future space and adjust details before construction begins.'
      },
      {
        question: 'How long does it take to get the plans?',
        answer: 'Timelines depend on project complexity. For an individual house, expect about 2 to 4 weeks for sketches and preliminary plans, then 4 to 8 weeks for complete execution plans. We define a realistic schedule together from the start.'
      },
      {
        question: 'Do you handle building permit applications?',
        answer: 'Yes, we prepare all necessary technical documents: plans, sections, elevations, and descriptive notes. We can also assist you with administrative procedures with the relevant authorities in Madagascar.'
      },
      {
        question: 'Do you offer construction site supervision?',
        answer: 'Absolutely. Site supervision is part of our services. We coordinate the different trades, verify that work complies with the plans, and organize regular visits to ensure quality and respect of deadlines for your construction.'
      },
      {
        question: 'What are your fees?',
        answer: 'Our rates vary according to the nature and scope of the project. We generally offer a fixed price for design (plans + 3D) and a percentage of construction costs for site supervision. Contact us to receive a free personalized quote.'
      },
      {
        question: 'Do you work on renovation projects?',
        answer: 'Yes, we work on new constructions as well as renovations and extensions. For renovations, we start with a precise survey of the existing structure to propose solutions adapted to your needs while respecting the building\'s constraints.'
      }
    ]
  },

  // History Section
  history: {
    title: 'OUR HISTORY',
    milestones: [
      {
        year: '2023',
        title: 'M.A Concept Creation',
        description: 'M.A Concept was founded with an ambitious vision: to offer modern, innovative architectural services tailored to each client\'s needs. From the beginning, the company has distinguished itself through creativity, professionalism, and commitment to quality.',
        features: []
      },
      {
        year: '2025',
        title: 'Strategic Collaborations',
        description: 'M.A Concept reaches a new milestone through collaborations with MIRALUX and SIGMA Technologie, two major players located on Réunion Island. These partnerships strengthen our expertise in several key areas and allow us to integrate advanced technological solutions into our projects, offering our clients smarter, safer, and more efficient spaces.',
        features: [
          'Home Automation',
          'Security',
          'Audiovisual',
          'Lighting'
        ]
      },
      {
        year: '2026',
        title: 'Expansion into Real Estate',
        description: 'In 2026, M.A Concept  expands its scope by entering the real estate sector. Alongside architectural design and project development, the company now offers real estate services including land sales, property transactions, and professional real estate consulting. This strategic evolution allows us to provide end-to-end solutions, from land acquisition and architectural conception to property development and market-ready assets.',
      }

    ]
  },

  // Common
  common: {
    required: '*',
    loading: 'Loading...'
  }
};
